define('modules/audiences/segments/behavior/main',["T1Module"], function (T1Module) {
  "use strict";

  var instance;
  if (instance === undefined) {
    instance = new T1Module({
      name: "audiences/segments/behavior",
      viewCfgs: {
        segments: {}
      },
      defaultView: "addBehavior"
    });
  }
  return instance;
});
